import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowRight, Ticket, Building2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { eventDetails } from '../data/mock';

const FinalCTASection = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <section ref={ref} className="section-padding">
      <div className="container mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          className="relative max-w-4xl mx-auto text-center p-8 md:p-12 lg:p-16 rounded-2xl md:rounded-3xl overflow-hidden"
        >
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-br from-[var(--bg-secondary)] to-[rgba(218,255,1,0.05)]" />
          <div className="absolute inset-0 border border-[var(--accent-primary)] rounded-2xl md:rounded-3xl" />
          
          {/* Decorative elements */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-[var(--accent-primary)] to-transparent" />
          <div className="absolute -top-20 -left-20 w-40 h-40 bg-[var(--accent-primary)] opacity-10 rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -right-20 w-40 h-40 bg-[var(--accent-primary)] opacity-10 rounded-full blur-3xl" />
          
          <div className="relative z-10">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6">
              Ready to Meet 100s of
              <span className="block text-[var(--accent-primary)]">DeFi Protocol Teams?</span>
            </h2>
            
            <p className="text-base md:text-lg text-[var(--text-secondary)] mb-6 md:mb-8 max-w-2xl mx-auto">
              Join us on {eventDetails.date} for the premier virtual summit for DeFi protocol collaboration. Early bird pricing ends soon.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <a
                href="https://luma.com/6kdsrxks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button 
                  className="w-full sm:w-auto bg-[var(--accent-primary)] text-[var(--bg-primary)] hover:bg-[var(--accent-hover)] h-12 md:h-14 px-6 md:px-8 rounded-xl text-sm md:text-base font-semibold transition-all hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(218,255,1,0.3)]"
                  data-testid="final-cta-get-tickets"
                >
                  <Ticket className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                  Get Tickets from $297
                  <ArrowRight className="w-4 h-4 md:w-5 md:h-5 ml-2" />
                </Button>
              </a>
              <a
                href="https://luma.com/6kdsrxks"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button 
                  variant="outline"
                  className="w-full sm:w-auto border-2 border-[var(--border-primary)] text-white hover:border-[var(--accent-primary)] hover:text-[var(--accent-primary)] hover:bg-[var(--accent-bg)] h-12 md:h-14 px-6 md:px-8 rounded-xl text-sm md:text-base font-semibold transition-all"
                  data-testid="final-cta-become-sponsor"
                >
                  <Building2 className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                  Become a Sponsor
                </Button>
              </a>
            </div>
            
            <p className="text-xs md:text-sm text-[var(--text-muted)] mt-4 md:mt-6">
              Limited spots. Secure your place today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
